export default "__VITE_ASSET__69be3956__"